import { memo } from 'react'

export default memo(function EditIcon(props: any) {
  return (
    <svg
      width={props.size || '48px'}
      height={props.size || '48px'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9 43.4C22.6 43.5 23.3 43.5 24 43.5C28.5 43.5 32.8 42 36.2 39.2C40.3 36 42.8 31.3 43.4 26.1C44.6 15.4 36.8 5.8 26.1 4.6C21.8 4.2 17.5 5.1 13.8 7.4C13.2 7.7 13 8.5 13.4 9.1C13.7 9.7 14.5 9.9 15.1 9.5C18.3 7.5 22 6.6 25.9 7C35.2 8 42 16.5 41 25.8C40.5 30.3 38.2 34.3 34.7 37.2C31.2 40.1 26.7 41.4 22.2 40.9C17.6 40.5 13.6 38.2 10.7 34.7C7.8 31.2 6.5 26.7 7 22.2C7.3 19.6 8.1 17.2 9.5 15C9.9 14.4 9.7 13.7 9.1 13.3C8.5 12.9 7.8 13.1 7.4 13.7C5.9 16.2 4.9 18.9 4.6 21.9C4 27.1 5.5 32.2 8.8 36.2C12 40.3 16.7 42.8 21.9 43.4ZM30.7 32.7C31 33 31.3 33.1 31.6 33.1C31.9 33.1 32.3 32.9 32.5 32.7C33 32.2 33 31.4 32.5 30.9L25.7 24L32.6 17.1C33.1 16.6 33.1 15.8 32.6 15.3C32.1 14.8 31.3 14.8 30.8 15.3L23.9 22.2L17.1 15.3C16.6 14.8 15.8 14.8 15.3 15.3C14.8 15.8 14.8 16.6 15.3 17.1L22.1 24L15.3 30.8C14.8 31.3 14.8 32.1 15.3 32.6C15.8 33.1 16.6 33.1 17.1 32.6L23.9 25.8L30.7 32.7Z"
        fill={props.color || '#888'}
      ></path>
    </svg>
  )
})
